/*
 * Copyright (c) 2022. Haodong JU
 */

import GlobalSettings from '@/GlobalSettings'
import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import AttributeGroup from './AttributeGroup'
import CategoryType from './CategoryType'
import store from '@/store'
import i18n from '@/i18n'
import PaymentColors from '@/model/common/PaymentColors'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    form: false,
    header: false,
  },
  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      required: false,
      type: {
        root: () => store.getters.rootUrl + GlobalSettings.dcImageRoot,
      },
    },
  },
  name: {},
  printMod: {
    displayName: 'printMod',
    header: false,
  },
  priceMod: {
    type: IKDataEntity.Types.Float,
    displayName: 'priceMod',
    formConfig: {
      overwriteRule: true,
      rule: [
        v => /^(-)?[0-9]+\.{0,1}[0-9]{0,2}$/.test(v) || this.$t('pls_enter_the_correct_price'),
      ],
    },
  },
  attributeGroupId: {
    displayName: 'groupName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: AttributeGroup.forceGetList,
      },
    },
    header: false,
  },
  value: {
    displayName: 'sort',
    formConfig: {
      default: 1,
    },
    header: false,
  },

  dishesCategoryTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      default: 9,
      type: {
        selectItems: CategoryType.getList,
        color: PaymentColors.getList(),
      },
    },
  },
  frontendHide: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
    },
  },
  isActive: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true,
    },
  },

}
const config = {
  add: async function (item) {
    return (await hillo.postWithUploadFile('Category.php?op=addAttribute', item)).content
  },
  edit: function (item) {
    return hillo.postWithUploadFile('Category.php?op=updateAttribute', item)
  },
  remove: function (id) {
    return hillo.post('Category.php?op=deleteAttribute', { id: id })
  },
  load: async function (filter) {
    return (await hillo.get('Category.php', {
      op: 'showAttribute',
      lang: GlobalSettings.getLang(),
    }))
      .content
  },
  name: function () {
    return i18n.t('attriubte')
  },
}

export default IKDataEntity.ModelFactory(entity, config)
